import styled from "styled-components";
import { Drawer, ListItem } from "@material-ui/core";
import { SIDE_PANEL_OFFSET } from "styles/utils";

export const SidePanelDrawer = styled(Drawer)`
    width: ${SIDE_PANEL_OFFSET}px;
    flex-shrink: 0;

    .MuiDrawer-paper {
        width: 300px;
    }
`;

export const NestedListItem = styled(ListItem)`
    padding-left: ${({ theme }) => theme.spacing(3)}px;
`;
